import { EditOutlined } from "@ant-design/icons";
import { Button, Card, Modal, Tooltip } from "antd";
import React, { useState } from "react";
import DeviceForm from "../device-details-form.tsx/DeviceDetailsForm";
import { useDispatch } from "react-redux";
import {
  AppDispatch,
  getDeviceClear,
  getDeviceRequest,
} from "@src/redux";
import { deviceImages } from "@src/helpers/constants";
import { useCheckPageComponentAccess } from "@src/hooks/index";
import { useTranslation } from "react-i18next";

interface DeviceBrand {
  id: string;
  name: string;
  deviceType: string;
}

interface DeviceDetailsCardProps {
  device: {
    id?: string;
    name?: string;
    type?: string;
    image?: string;
    referenceId?: string;
    macAddress?: string;
    brand?: DeviceBrand;
    kitName: string;
  };
}

const DeviceDetailsCard: React.FC<DeviceDetailsCardProps> = ({ device }) => {
  const dispatch = useDispatch<AppDispatch>();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [mutationType, setMutationType] = useState<"edit" | "add">("edit");
  const { t } = useTranslation();

  const onEditOpen = (id: string | undefined) => {
    if (id) {
      dispatch(
        getDeviceRequest({
          filter: {
            id: id,
          },
        })
      );
    }
    setMutationType("edit");
    setModalOpen(true);
  };

  const handleCancel = () => {
    setModalOpen(false);
    dispatch(getDeviceClear());
  };

  const isAssigned = Boolean(device?.kitName);

  return (
    <>
      <Card className="device-card" hoverable key={device?.id}>
        <div className="device-card-gradient-top" />
        <div
          className={`device-status-pill ${
            isAssigned ? "device-status-pill--active" : "device-status-pill--idle"
          }`}
        >
          <span className="device-status-dot" />
          {isAssigned ? t("assigned") || "Assigned" : t("unassigned") || "Idle"}
        </div>
        <div className="device-image-container">
          <div className="device-image-halo">
            <img
              src={
                device?.brand
                  ? deviceImages?.[device?.brand?.deviceType || ""]
                  : ""
              }
              className="device-image"
              alt="Device"
            />
          </div>
        </div>
        <div className="device-info">
          <Tooltip title={device?.referenceId}>
            <h3 className="device-name">{device?.referenceId}</h3>
          </Tooltip>
          <div className="device-mac">
            <span className="device-mac-label">MAC</span>
            <span className="device-mac-value">{device?.macAddress || "-"}</span>
          </div>
          <div className="device-brand-badge">
            <span className="device-brand-dot" />
            {device?.brand?.name || "Unknown Brand"}
          </div>
          <div className="kit-container">
            <span className="kit-label">{t("kit")}</span>
            <span className="kit-value">{device?.kitName ?? "-"}</span>
          </div>
        </div>
        {useCheckPageComponentAccess("edit_device_action") && (
          <Tooltip title={t("edit_device") || "Edit device"}>
            <Button
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
              className="edit-button"
              onClick={() => onEditOpen(device?.id || "")}
            />
          </Tooltip>
        )}
      </Card>
      <Modal
        title={
          <span
            style={{ fontFamily: "Abel", fontSize: "18px", fontWeight: "bold" }}
          >
            {t("edit_device")}
          </span>
        }
        open={modalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <DeviceForm
          mutationType={mutationType}
          handleCancel={handleCancel}
          deviceId={device?.id}
        />
      </Modal>
    </>
  );
};

export default DeviceDetailsCard;
